import { isPlatformServer, TitleCasePipe, Location } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import * as signalR from '@microsoft/signalr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { toLower, toUpper } from 'lodash';
import { NgxImageCompressService } from 'ngx-image-compress';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { combineLatest, map, Observable, Subject, Subscription } from 'rxjs';
import { ConstantMessages } from 'src/app/common/ConstantMessages';
import { Constants } from 'src/app/common/Constants';
import { MessageService } from 'src/app/common/message.service';
import { HasUnsavedData } from 'src/app/hasunsaveddata';
import { SeoService } from 'src/app/seo.service';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { HowItWorksComponent } from 'src/app/shared/components/howitworks/howitworks.component';
import { LoginComponent } from 'src/app/shared/components/Login/Login.component';
import { environment } from 'src/environments/environment';
import { ImageCropperControlComponent } from '../image-cropper-control/image-cropper-control.component';
import { FooterService } from 'src/app/footer.service';
declare var $: any;
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { InsTextComponent } from '../ins-text/ins-text.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'personalize',
  templateUrl: './Personalization.component.html',
  styleUrls: ['./Personalization.component.scss'],
  providers: [HTTPService, MessageService, TitleCasePipe],
})
export class Personalizationcomponent
  implements OnInit, HasUnsavedData, OnDestroy, AfterViewInit {
  subscription = new Subscription();

  @ViewChild('mobileReorder') mobileReorder: ElementRef;
  @ViewChild('sliderThumbnails') sliderThumbnails: ElementRef;
  @ViewChild('btnRowFixed') btnRowFixed: ElementRef;
  @ViewChild('mobilePreviewContainer') mobilePreviewContainer: ElementRef;
  @ViewChild('firstInput', { static: false }) firstInput: ElementRef;
  public constants: Constants;
  public constantMessages: ConstantMessages;
  userDetails: any = {};
  userId: number;
  public pageSize: any = 0;
  public messageType: any;
  public pTemplateId: any = '';
  public pUserVideoId: any = '';
  fileList: any = [];
  singleFileList: any = [];
  spinnerVisible: boolean = false;
  IsDefaultAudio: boolean = true;
  editImageFile;
  croppedImageFile;
  fieldName;
  public videoPath: any = '';
  public documentPath: any = '';
  public progressPercentValue: any = 0;

  public CategoryData: any;
  TemplateMetaData: any = {};
  public isSlideStepsLoading: boolean = false;
  public isShowLoader: boolean = true;
  public jobProgressData;
  public tempUserId = 0;
  public uniqueTemplateId;
  public uploadMusicText = 'Upload Your Music';
  @ViewChild('imageCropperModal') private imageCropperModal;
  @ViewChild('personalizeVideo') public personalizeVideo;
  ProgressBarClass = 'c100 p0 green';
  ProgressTaskClass = 'mb-0 orange';
  ProgressBarPercentage = '0';
  Task1Width = 'width:0%';
  isOpen;
  selectedContent: string = '';
  public isShowPreviewStatusStyle = 'display:none;';
  public isShowPreviewStatus: boolean = false;
  public isDraftSaved: boolean = false;
  public isInputChanged: boolean = false;
  public generatedVideoPath: string = '';
  public generatedDocumentPath: string = '';
  public oldFileList: any;
  public oldTemplateData: any;
  isIosDevice = false;
  public isCarouselChangedFromSaveDraft: boolean = false;
  @ViewChild('audioFile')
  audioFile: ElementRef;
  public audioFilePath: string;
  public audioFileName: string;
  public isPageDataLoaded: boolean = false;
  isPersonalizeDataLoaded: boolean = false;
  isMaintainAspectRatio: boolean = true;
  aspectRatio: any = 1 / 1;
  fieldShapeId: any = 1;
  cropperMinWidth: number = 256;
  public isSaveDisable: boolean = false;
  public isPayDisable: boolean = false;
  public imageUploading: boolean = false;
  public marketingAgent: string;
  previewGenerationInProgress = false;
  connection: signalR.HubConnection;
  templateName: string;
  assetURL = environment.assetURL;
  displayType: number = 1;
  videoDesc = '';
  audioList = [];
  showAudioPlayer = false;
  customAudioPath = '';
  audioPath = '';
  slideExclude: any[] = [];
  finalAudioPath = '';
  TemplateAudio = [];
  isFromServer = false;
  previewStyle = '';
  invitationType;
  videoOrCardTextCap = 'Video';
  videoOrCardTextSmall = 'video';

  constructor(
    private ngbModel: NgbModal,
    private renderer: Renderer2,
    private _httpService: HTTPService,
    private _router: Router,
    private messageService: MessageService,
    public toastr: ToastrService,
    vcr: ViewContainerRef,
    private modalService: NgbModal,
    private _route: ActivatedRoute,
    private dialog: MatDialog,
    public sharedService: SharedService,
    private imageCompress: NgxImageCompressService,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) public platformId,
    private transferState: TransferState,
    private cdr: ChangeDetectorRef,
    private titlecasePipe: TitleCasePipe,
    private footerService: FooterService,
    private deviceService: DeviceDetectorService,
    private location: Location
  ) {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (this.userDetails != null && this.userDetails != undefined)
      this.tempUserId = this.userDetails.UserId;
    this.constants = new Constants();
    this.constantMessages = new ConstantMessages();
    this.messageType = this.constants.messageType;
  }
  @HostListener('window:beforeunload')
  hasUnsavedData(): Observable<boolean> | boolean {
    let result = this.isInputChanged || this.isShowPreviewStatus;
    return result;
  }

  beforeUnloadHandler(event: any) {
    if (this.isInputChanged || this.isShowPreviewStatus) {
      const subject = new Subject<boolean>();

      const modelRef = this.modalService.open(ConfirmationBoxComponent);
      modelRef.componentInstance.title = 'Plese confirm';
      modelRef.componentInstance.message =
        'WARNING: Video generation is in progress. Click “Okay” to save changes continue video creation OR click “Cancel Video Generation” to stop video creation and lose all changes.';
      modelRef.componentInstance.okButtonText = 'Cancel';
      modelRef.componentInstance.cancelButtonText = 'Okay';
      modelRef.componentInstance.subject = subject;
      modelRef.result.then((data: any) => {
        subject.complete();
      });
      event.preventDefault();
      return subject.asObservable();
    }
  }
  owlOptions: OwlOptions = {
    loop: false,
    margin: 0,
    touchDrag: false,
    pullDrag: true,
    mouseDrag: false,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    items: 1,
    nav: true,
    autoHeight: true,
    autoplay: false,
  };
  activeSlide = 0;

  questionOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    margin: 16,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    items: 1,
    nav: false,
    autoHeight: true,
    autoplay: true,
  };
  ngOnInit() {
    this.subscription.add(
      combineLatest([this._route.params, this._route.queryParams])
        .pipe(map((results) => ({ params: results[0], query: results[1] })))
        .subscribe((results) => {
          const queryData = this.sharedService.decryptAndParseQueryString(
            results.params.data
          );
          if (queryData != undefined) {
            this.pTemplateId = queryData.templateId;
            this.pUserVideoId = queryData.userVideoId;
            this.marketingAgent = queryData.marketingAgent;
            this.invitationType = queryData.invitationType;
            if (this.invitationType == 2) {
              this.videoOrCardTextCap = 'Card';
              this.videoOrCardTextSmall = 'card';
            } else {
              this.invitationType = 1;
            }
          }
          this.videoDesc = results.params.videoDesc;
          this.sharedService.isShowLoader.next(true);
          this.isSlideStepsLoading = true;

          if (!isNaN(this.pTemplateId) && this.pTemplateId > 0) {
            this.GetTemplateDataList();
          } else {
            this.GetUserVideoDataList();
          }
        })
    );
    this.footerService.toggleFooterVisibility(false);
    this.footerService.toggleWhatsappVisibility(false);
    setTimeout(() => {
      this.footerService.toggleTidioChatVisibility(false);
    }, 6000);
    this.renderer.addClass(document.body, 'body-no-scroll');
    let deviceInfo = this.deviceService.getDeviceInfo();
    if (deviceInfo?.os?.toLowerCase() == 'ios') {
      this.isIosDevice = true;
    }
    this.renderer.addClass(document.body, 'hide-header-from-personlized');
  }
  ngAfterViewInit() { }

  public connectSignalR = () => {
    console.log('connect');
    this.connection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Information)
      .withUrl(`${this._httpService.baseURL}jobprogress`)
      .build();
    this.connection.serverTimeoutInMilliseconds = 1000 * 60 * 1000;
    this.connection
      .start()
      .then(() => { })
      .catch(function (err) {
        return console.error(err.toString());
      });
  };
  public invokeHubConnection = () => {
    let uniqueTemplateId = this.uniqueTemplateId;
    if (uniqueTemplateId != null) {
      if (this.connection.state == signalR.HubConnectionState.Disconnected) {
        this.connection.start().then(() => {
          this.connection
            .invoke('AssociateJob', `${uniqueTemplateId}`)
            .catch(function (e) { })
            .finally(() => {
              this.processVideoGeneration();
            });
        });
      } else {
        this.connection
          .invoke('AssociateJob', `${uniqueTemplateId}`)
          .catch(function (e) { })
          .finally(() => {
            this.processVideoGeneration();
          });
      }
    } else {
      this.connection.invoke('AssociateJob', 'UnKnown');
    }
  };
  public hubConnectionOn = () => {
    this.connection.on('progress', (data) => {
      let responsedata = JSON.parse(data);
      if (responsedata != undefined) {
        this.jobProgressData = responsedata;
        this.Task1Width = 'width:100%';
        this.ProgressBarPercentage = responsedata.TaskCompletePercentage;
        this.ProgressBarClass = `c100 p${responsedata.TaskCompletePercentage} green`;
        this.Task1Width = 'width:100%';
        if (parseInt(this.ProgressBarPercentage) > 0) {
          this.ProgressTaskClass = 'green mb-0';
        }
      }
    });
  };

  public GetTemplateDataList() {
    const Personalise_Key = makeStateKey('Personalise_Key');
    if (this.transferState.hasKey(Personalise_Key)) {
      const data = this.transferState.get(Personalise_Key, null);
      if (!isPlatformServer(this.platformId)) {
        this.isFromServer = false;
        this.transferState.remove(Personalise_Key);
      }
      this.ProcessGetTemplate(data);
    } else {
      this.subscription.add(
        this._httpService
          .ajaxPost('Personalize/GetTemplateData', {
            pTemplateId: this.pTemplateId,
          })
          .subscribe(
            (data) => {
              if (isPlatformServer(this.platformId)) {
                this.isFromServer = true;
                this.transferState.set(Personalise_Key, data);
              }
              this.ProcessGetTemplate(data);
            },
            (error: any) => {
              this.isSlideStepsLoading = false;
              this.sharedService.isShowLoader.next(false);
            }
          )
      );
    }
  }

  private ProcessGetTemplate(data: any) {
    if (data['Message'].MessageTypeValue == this.messageType.Success) {
      this.sharedService.isPageDataLoaded = true;
      this.isPersonalizeDataLoaded = true;
      var templateDataList = data['TemplateData'];
      this.displayType = templateDataList.DisplayType;
      this.seoService.generateTags({
        title: `Personalise ${templateDataList.VideoName} | video invitation | Online Video Invitation Maker | Create Online Video Invitations - Wedding, Engagement, Birthday, Anniversary & more. - 247Invites.com`,
        description: `Personalise ${templateDataList.VideoName} video invitation | Create Customized Video Invitations Online for Wedding, Engagement, Birthday, Reception, Anniversary, House warming, Naamkaran, Cradle, Baptism, Christening, Half Sari, Valentines Day, Christmas, Diwali, New Year, etc. Download and share using WhatsApp, Facebook, and more.`,
        image: `${this.assetURL}/${templateDataList.ThumbnailImage}`,
        slug: this._router.url,
      });
      if (this.userDetails != null)
        this.TemplateMetaData.UserId = this.userDetails.UserId;
      this.TemplateMetaData.UserVideoId = templateDataList.UserVideoId;
      this.TemplateMetaData.TemplateId = templateDataList.TemplateId;
      this.TemplateMetaData.TemplateName = templateDataList.TemplateName;
      this.TemplateMetaData.VideoDuration = templateDataList.VideoDuration;
      this.TemplateMetaData.AudioPath = templateDataList.AudioPath;
      this.audioFilePath =
        this._httpService.baseURLWithOutSlace +
        (templateDataList.AudioPath.indexOf('.') == 0
          ? templateDataList.AudioPath.substring(1)
          : templateDataList.AudioPath);
      this.audioFileName = this.audioFilePath
        .replace(/^.*[\\\/]/, '_')
        .replace(/\s/g, '_');
      this.audioFileName = this.replaceBetween(
        this.audioFileName,
        this.audioFileName.lastIndexOf('_'),
        this.audioFileName.lastIndexOf('.'),
        ''
      );
      this.uniqueTemplateId = templateDataList.UniqueTemplateId;
      if (!isPlatformServer(this.platformId)) {
        this.connectSignalR();
        this.hubConnectionOn();
      }
      var SlideData = [];
      templateDataList.SlideData.forEach((element) => {
        var SlideDataObj = {
          SlideId: 0,
          SlideName: '',
          SlideImageLink: '',
          SlideSequence: '',
          SlidePreviewFormate: '',
          IsIncluded: true,
          FieldData: [],
        };
        SlideDataObj.SlideId = element.SlideId;
        SlideDataObj.SlideName = element.SlideName;
        SlideDataObj.SlideImageLink =
          this.assetURL + '/' + element.SlideImageLink;
        SlideDataObj.SlideSequence = element.SlideSequence;
        SlideDataObj.SlidePreviewFormate = element.SlidePreviewFormate;
        SlideDataObj.FieldData = [];
        if (element.FieldData != null) {
          element.FieldData.forEach((elementField) => {
            var FieldDataObj = {
              FieldId: 0,
              FieldType: '',
              FieldName: '',
              FieldValue: '',
              FieldToolTip: '',
              IsOptional: false,
              FileEvent: '',
              FileCroppedValue: '',
              IsEdited: false,
              FieldLength: '',
              AspectRatio: '',
              CasingTypeId: '',
              FieldShapeId: '',
              IsRemoveBg: ''
            };
            FieldDataObj.FieldId = elementField.FieldId;
            FieldDataObj.FieldType = elementField.FieldType;
            FieldDataObj.FieldName = elementField.FieldName;
            FieldDataObj.FieldValue = elementField.FieldValue;
            FieldDataObj.IsOptional = elementField.IsOptional;
            FieldDataObj.FieldLength = elementField.FieldLength;
            FieldDataObj.AspectRatio = elementField.AspectRatio;
            FieldDataObj.CasingTypeId = elementField.CasingTypeId;
            FieldDataObj.FieldShapeId = elementField.FieldShapeId;
            FieldDataObj.FieldToolTip = elementField.FieldToolTip;
            FieldDataObj.IsRemoveBg = elementField.IsRemoveBg;
            if (
              FieldDataObj.FieldType != null &&
              FieldDataObj.FieldType.toLowerCase().indexOf('picture') != -1 &&
              FieldDataObj.FieldType.toLowerCase() != '' &&
              elementField.FieldValue != ''
            ) {

              FieldDataObj.FileCroppedValue =
                this.assetURL + '/' + elementField.FieldValue;
            }
            SlideDataObj.FieldData.push(FieldDataObj);
          });
        }
        let slideIncludeFilter = SlideDataObj.FieldData.filter(
          (x) => x.FieldName == 'SlideInclude'
        );
        if (slideIncludeFilter.length == 0) {
          SlideDataObj.IsIncluded = true;
        } else {
          let slideInclude = slideIncludeFilter[0].FieldValue;
          if (slideInclude != undefined && slideInclude != '') {
            SlideDataObj.IsIncluded = slideInclude == 'false' ? false : true;
          }
        }
        SlideData.push(SlideDataObj);
      });
      this.TemplateMetaData.SlideData = SlideData;
      this.HandleTemplateAudio(templateDataList);
      this.TemplateMetaData.TemplateAudio = this.TemplateAudio;
      let selectedAudio = this.TemplateMetaData.TemplateAudio.filter(
        (x) => x.IsDefault == true
      )[0];
      this.audioPath = selectedAudio.AudioPath;
      this.changeAudio(selectedAudio.AudioPath);
      this.isSlideStepsLoading = false;
      this.isPayDisable = true;
    } else {
      this.messageService.showMessage(
        data['Message'].Text,
        data['Message'].MessageTypeValue
      );
      this.isSlideStepsLoading = false;
    }
    this.sharedService.isShowLoader.next(false);
  }

  public GetUserVideoDataList() {
    this.subscription.add(
      this._httpService
        .ajaxPost('Personalize/GetUserVideoDataList', {
          pUserVideoId: this.pUserVideoId,
        })
        .subscribe(
          (data) => {
            try {
              if (
                data['Message'].MessageTypeValue == this.messageType.Success
              ) {
                if (!isPlatformServer(this.platformId)) {
                  if (data.TemplateData.VideoStatus == 3) {
                    this.redirectToDownloadVideo();
                  }
                }
                this.sharedService.isPageDataLoaded = true;
                this.isPersonalizeDataLoaded = true;
                var templateDataList = data['TemplateData'];
                this.seoService.generateTags({
                  title: `Personalise ${templateDataList.VideoName} | video invitation | Online Video Invitation Maker | Create Online Video Invitations - Wedding, Engagement, Birthday, Anniversary & more. - 247Invites.com`,
                  description: `Personalise ${templateDataList.VideoName} |  video invitation | Create Customized Video Invitations Online for Wedding, Engagement, Birthday, Reception, Anniversary, House warming, Naamkaran, Cradle, Baptism, Christening, Half Sari, Valentines Day, Christmas, Diwali, New Year, etc. Download and share using WhatsApp, Facebook, and more.`,
                  image: `${this.assetURL}/${templateDataList.ThumbnailImage}`,
                });
                if (this.userDetails != null)
                  this.TemplateMetaData.UserId = this.userDetails.UserId;
                this.TemplateMetaData.UserVideoId =
                  templateDataList.UserVideoId;
                this.TemplateMetaData.TemplateId = templateDataList.TemplateId;
                this.TemplateMetaData.TemplateName =
                  templateDataList.TemplateName;
                this.TemplateMetaData.AudioPath = templateDataList.AudioPath;
                this.TemplateMetaData.DefaultAudioPath =
                  templateDataList.DefaultAudioPath;
                this.previewStyle = templateDataList.PreviewStyle;
                this.audioFilePath =
                  this._httpService.baseURLWithOutSlace +
                  (templateDataList.AudioPath.indexOf('.') == 0
                    ? templateDataList.AudioPath.substring(1)
                    : templateDataList.AudioPath);
                this.audioFileName = this.audioFilePath
                  .replace(/^.*[\\\/]/, '_')
                  .replace(/\s/g, '_');
                this.audioFileName = this.replaceBetween(
                  this.audioFileName,
                  this.audioFileName.lastIndexOf('_'),
                  this.audioFileName.lastIndexOf('.'),
                  ''
                );

                if (
                  (templateDataList.VideoPath != '' ||
                    templateDataList.DocumentPath != '') &&
                  templateDataList.IsUseS3Bucket == false
                ) {
                  this.generatedVideoPath =
                    this._httpService.baseURL + templateDataList.VideoPath;
                  this.generatedDocumentPath =
                    this._httpService.baseURL + templateDataList.DocumentPath;
                  this.isPayDisable = false;
                } else if (
                  templateDataList.VideoPath != '' &&
                  templateDataList.IsUseS3Bucket
                ) {
                  this.generatedVideoPath = templateDataList.VideoPath;
                  this.generatedDocumentPath = templateDataList.DocumentPath;
                  this.isPayDisable = false;
                } else this.isPayDisable = true;
                this.uniqueTemplateId = templateDataList.UniqueTemplateId;
                if (!isPlatformServer(this.platformId)) {
                  this.connectSignalR();
                  this.hubConnectionOn();
                }
                var SlideData = [];
                templateDataList.SlideData.forEach((element) => {
                  var SlideDataObj = {
                    SlideId: 0,
                    SlideName: '',
                    SlideImageLink: '',
                    SlideSequence: '',
                    SlidePreviewFormate: '',
                    IsIncluded: true,
                    FieldData: [],
                  };
                  SlideDataObj.SlideId = element.SlideId;
                  SlideDataObj.SlideName = element.SlideName;
                  SlideDataObj.SlideImageLink =
                    this.assetURL + '/' + element.SlideImageLink;
                  SlideDataObj.SlideSequence = element.SlideSequence;
                  SlideDataObj.SlidePreviewFormate =
                    element.SlidePreviewFormate;
                  SlideDataObj.FieldData = [];
                  if (element.FieldData != null) {
                    element.FieldData.forEach((elementField) => {
                      var FieldDataObj = {
                        FieldId: 0,
                        FieldType: '',
                        FieldName: '',
                        FieldValue: '',
                        FieldToolTip: '',
                        IsOptional: false,
                        FileEvent: '',
                        FileCroppedValue: '',
                        IsEdited: false,
                        FieldLength: '',
                        AspectRatio: '',
                        CasingTypeId: '',
                        FieldShapeId: '',
                        IsRemoveBg: ''
                      };
                      FieldDataObj.FieldId = elementField.FieldId;
                      FieldDataObj.FieldType = elementField.FieldType;
                      FieldDataObj.FieldName = elementField.FieldName;
                      FieldDataObj.FieldValue = elementField.FieldValue;
                      FieldDataObj.FieldLength = elementField.FieldLength;
                      FieldDataObj.AspectRatio = elementField.AspectRatio;
                      FieldDataObj.CasingTypeId = elementField.CasingTypeId;
                      FieldDataObj.FieldShapeId = elementField.FieldShapeId;
                      FieldDataObj.FieldToolTip = elementField.FieldToolTip;
                      FieldDataObj.IsRemoveBg = elementField.IsRemoveBg;

                      if (FieldDataObj.FieldType.toLowerCase() == 'picture') {
                        if (elementField.FieldValue.indexOf('asset') != -1) {
                          FieldDataObj.FileCroppedValue =
                            this.assetURL + '/' + elementField.FieldValue;
                        } else {
                          FieldDataObj.FileCroppedValue =
                            this._httpService.baseURL + elementField.FieldValue;
                        }
                      }

                      FieldDataObj.IsOptional = elementField.IsOptional;
                      SlideDataObj.FieldData.push(FieldDataObj);
                    });
                  }
                  let slideIncludeFilter = SlideDataObj.FieldData.filter(
                    (x) => x.FieldName == 'SlideInclude'
                  );
                  if (slideIncludeFilter.length == 0) {
                    SlideDataObj.IsIncluded = true;
                  } else {
                    let slideInclude = slideIncludeFilter[0].FieldValue;
                    if (slideInclude != undefined && slideInclude != '') {
                      SlideDataObj.IsIncluded =
                        slideInclude == 'false' ? false : true;
                    }
                  }
                  SlideData.push(SlideDataObj);
                });

                this.TemplateMetaData.SlideData = SlideData;
                this.HandleTemplateAudio(templateDataList);
                this.TemplateMetaData.TemplateAudio = this.TemplateAudio;
                let selectedAudio = this.TemplateMetaData.TemplateAudio.filter(
                  (x) => x.AudioPath == this.TemplateMetaData.AudioPath
                )[0];
                if (selectedAudio == undefined || selectedAudio.length == 0) {
                  this.HandleSingleTemplateAudio(
                    this.TemplateMetaData.AudioPath
                  );
                  this.TemplateMetaData.TemplateAudio = this.TemplateAudio;
                  this.changeAudio(this.TemplateMetaData.AudioPath);
                } else {
                  this.changeAudio(selectedAudio.AudioPath);
                }

                this.isSlideStepsLoading = false;
                if (
                  this.TemplateAudio.filter(
                    (x) =>
                      x.AudioPath == templateDataList.AudioPath && x.IsCustom
                  ).length > 0
                ) {
                  this.IsDefaultAudio = false;
                  this.uploadMusicText = 'Audio Uploaded!!';
                }
              } else {
                this.messageService.showMessage(
                  data['Message'].Text,
                  data['Message'].MessageTypeValue
                );
                this.isSlideStepsLoading = false;
              }
              this.sharedService.isShowLoader.next(false);
            } catch (error) {
              this.sharedService.isShowLoader.next(false);
            }
          },
          (error: any) => {
            if (!isPlatformServer(this.platformId)) {
              if (error.status == 401) {
                localStorage.removeItem('userDetails');
                const modelRef = this.ngbModel.open(LoginComponent, {
                  size: 'lg',
                  windowClass: 'login-dialog',
                });
                modelRef.result.then((data) => {
                  let userDetails = JSON.parse(
                    localStorage.getItem('userDetails')
                  );
                  if (userDetails != null && userDetails != '')
                    window.location.reload();
                  else this._router.navigate(['homepage']);
                });
              }
              this.isSlideStepsLoading = false;
              this.sharedService.isShowLoader.next(false);
            }
          }
        )
    );
  }

  private HandleTemplateAudio(templateDataList: any) {
    templateDataList.TemplateAudio.forEach((element) => {
      var templateAudioObj = {
        AudioPath: '',
        AudioTitle: '',
        TemplateId: 0,
        AudioCoverPath: '',
        TemplateAudioId: 0,
        IsDefault: false,
        IsCustom: false,
      };
      templateAudioObj.AudioCoverPath = element.AudioCoverPath;
      templateAudioObj.AudioTitle = element.AudioTitle;
      templateAudioObj.TemplateId = element.TemplateId;
      templateAudioObj.AudioPath = element.AudioPath;
      templateAudioObj.TemplateAudioId = element.TemplateAudioId;
      templateAudioObj.IsDefault = element.IsDefault;
      this.TemplateAudio.push(templateAudioObj);
    });
  }

  deleteImage(itemObj: any) {
    itemObj.FileCroppedValue = null;
  }

  handleAudioFileInput(e: Event, file: FileList) {
    if (file.item(0).type.match(/audio-*/)) {
      if (file.length > 0) {
        this.uploadMusicText = 'Audio Uploaded!!';
        this.IsDefaultAudio = false;
      } else {
        this.uploadMusicText = 'Upload Your Audio';
        this.IsDefaultAudio = true;
      }
      this.sharedService.isShowLoader.next(true);
      this.fileList = this.fileList.filter(
        (x) => x.fieldName != 'TemplateAudioFile'
      );
      this.fileList.push({
        fieldName: 'TemplateAudioFile',
        file: file.item(0),
      });
      this._httpService
        .ajaxPostFileList(
          `Personalize/UploadCustomAudio/${this.tempUserId}`,
          this.fileList,
          null
        )
        .then(
          (data) => {
            this.customAudioPath = data.AudioPath;
            this.HandleSingleTemplateAudio(data.AudioPath);
            this.TemplateMetaData.TemplateAudio = this.TemplateAudio;
            this.changeAudio(data.AudioPath, true);
            this.sharedService.isShowLoader.next(false);
          },
          () => {
            this.sharedService.isShowLoader.next(false);
          }
        );
    } else {
      e.preventDefault();
      this.toastr.error('Please upload valid audio file.');
    }
  }
  private HandleSingleTemplateAudio(audioPath: string) {
    var templateAudioObj = {
      AudioPath: '',
      AudioTitle: '',
      TemplateId: 0,
      AudioCoverPath: '',
      TemplateAudioId: 0,
      IsDefault: false,
      IsCustom: false,
    };
    templateAudioObj.AudioCoverPath = '';
    templateAudioObj.AudioTitle = this.replaceBetween(
      audioPath.replace(/^.*[\\\/]/, '_').replace(/\s/g, '_'),
      audioPath.lastIndexOf('_'),
      audioPath.lastIndexOf('.'),
      ''
    );
    templateAudioObj.AudioPath = audioPath;
    templateAudioObj.TemplateAudioId = -1;
    templateAudioObj.IsDefault = false;
    templateAudioObj.IsCustom = true;
    this.TemplateAudio.push(templateAudioObj);
  }

  public SaveTemplateData(isGenerateVideo: boolean = false) {
    if (this.isShowPreviewStatus) {
      return;
    }
    this.sharedService.isShowLoader.next(true);
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    var errorExist = false;
    this.TemplateMetaData.SlideData.forEach((element) => {
      if (errorExist == false) {
        let slideIncludeField = element.FieldData.filter(
          (x) => x.FieldName == 'SlideInclude'
        )[0];
        element.FieldData.forEach((elementObj) => {
          if (!errorExist) {
            if (
              elementObj.FieldType.toLowerCase() == 'picture' &&
              elementObj.IsOptional == false &&
              (slideIncludeField.FieldValue.toString() == 'false'
                ? false
                : true)
            ) {
              if (elementObj.FileCroppedValue == '') {
                this.toastr.error('Please select all images from all slides.');
                errorExist = true;
                this.sharedService.isShowLoader.next(false);
                return;
              }
            }
          }
        });
      }
    });

    if (
      this.TemplateMetaData.SlideData.filter((x) => x.IsIncluded == true)
        .length == 0
    ) {
      this.toastr.error('Include atleast one slide to generate video.');
      errorExist = true;
    }
    if (errorExist) {
      this.sharedService.isShowLoader.next(false);
      return;
    }

    this.spinnerVisible = true;

    this.TemplateMetaData.VideoStatus = isGenerateVideo
      ? this.constants.videoStatus.Previewed
      : this.constants.videoStatus.Draft;
    if (this.userDetails != null) {
      if (
        this.TemplateMetaData.userId == null ||
        this.TemplateMetaData.userId == undefined
      )
        this.TemplateMetaData.userId = this.userDetails.UserId;

      this.TemplateMetaData.AudioPath = this.audioPath;
      this.TemplateMetaData.MarketingAgent = this.marketingAgent;
      this.TemplateMetaData.InvitationType = this.invitationType;
      this._httpService
        .ajaxPost('Personalize/SaveTemplateData', this.TemplateMetaData)
        .subscribe(
          (data) => {
            this.spinnerVisible = false;
            this.generatedVideoPath = '';
            if (
              data['Message'].MessageTypeValue ==
              this.constants.messageType.Success
            ) {
              this.isDraftSaved = true;
              this.isInputChanged = false;
              var templateDataList = data['TemplateData'];
              this.TemplateMetaData.UserId = this.userDetails.UserId;
              this.TemplateMetaData.UserVideoId = templateDataList.UserVideoId;
              this.TemplateMetaData.TemplateId = templateDataList.TemplateId;
              this.TemplateMetaData.TemplateName =
                templateDataList.TemplateName;
              this.TemplateMetaData.AudioPath = templateDataList.AudioPath;
              this.TemplateMetaData.DefaultAudioPath =
                templateDataList.DefaultAudioPath;
              this.TemplateMetaData.GenerateType =
                templateDataList.GenerateType;
              this.TemplateMetaData.GradeId = templateDataList.GradeId;
              this.previewStyle = templateDataList.PreviewStyle;
              this.audioFilePath =
                this._httpService.baseURLWithOutSlace +
                (templateDataList.AudioPath.indexOf('.') == 0
                  ? templateDataList.AudioPath.substring(1)
                  : templateDataList.AudioPath);
              this.audioFileName = this.audioFilePath
                .replace(/^.*[\\\/]/, '_')
                .replace(/\s/g, '_');
              this.audioFileName = this.replaceBetween(
                this.audioFileName,
                this.audioFileName.lastIndexOf('_'),
                this.audioFileName.lastIndexOf('.'),
                ''
              );
              this.pUserVideoId = templateDataList.UserVideoId;
              if (
                this.TemplateAudio.filter(
                  (x) => x.AudioPath == templateDataList.AudioPath && x.IsCustom
                ).length > 0
              ) {
                this.IsDefaultAudio = false;
                this.uploadMusicText = 'Audio Uploaded!!';
              } else {
                this.IsDefaultAudio = true;
                this.uploadMusicText = 'Upload Your Audio';
              }
              var SlideData = [];
              templateDataList.SlideData.forEach((element) => {
                var SlideDataObj = {
                  SlideId: 0,
                  SlideName: '',
                  SlideImageLink: '',
                  SlideSequence: '',
                  FieldData: [],
                };
                SlideDataObj.SlideId = element.SlideId;
                SlideDataObj.SlideName = element.SlideName;
                SlideDataObj.SlideImageLink =
                  this.assetURL + '/' + element.SlideImageLink;
                SlideDataObj.SlideSequence = element.SlideSequence;
                SlideDataObj.FieldData = [];
                if (element.FieldData != null) {
                  element.FieldData.forEach((elementField) => {
                    var FieldDataObj = {
                      FieldId: 0,
                      FieldType: '',
                      FieldName: '',
                      FieldValue: '',
                      FieldToolTip: '',
                      IsOptional: false,
                      FileEvent: '',
                      FileCroppedValue: '',
                      IsEdited: false,
                      FieldLength: '',
                      AspectRatio: '',
                      CasingTypeId: '',
                      IsRemoveBg: ''
                    };
                    FieldDataObj.FieldId = elementField.FieldId;
                    FieldDataObj.FieldType = elementField.FieldType;
                    FieldDataObj.FieldName = elementField.FieldName;
                    FieldDataObj.FieldValue = elementField.FieldValue;
                    FieldDataObj.FieldLength = elementField.FieldLength;
                    FieldDataObj.FieldToolTip = elementField.FieldToolTip;
                    FieldDataObj.AspectRatio = elementField.AspectRatio;
                    FieldDataObj.CasingTypeId = elementField.CasingTypeId;
                    FieldDataObj.IsRemoveBg = elementField.IsRemoveBg;
                    if (FieldDataObj.FieldType.toLowerCase() == 'picture') {
                      FieldDataObj.FileCroppedValue =
                        this._httpService.baseURL + elementField.FieldValue;
                    }

                    FieldDataObj.IsOptional = elementField.IsOptional;
                    SlideDataObj.FieldData.push(FieldDataObj);
                  });
                }
                SlideData.push(SlideDataObj);
              });

              this.isCarouselChangedFromSaveDraft = true;
              if (!isGenerateVideo) this.toastr.success(data['Message'].Text);
              this.sharedService.isShowLoader.next(false);
              if (isGenerateVideo) {
                this.createVideo();
              }
            } else {
              this.toastr.error(data['Message'].Text);
              this.sharedService.isShowLoader.next(false);
            }
          },
          (error: any) => {
            this.spinnerVisible = false;
            this.toastr.error(JSON.parse(error).Message['Text']);
            this.sharedService.isShowLoader.next(false);
          }
        );
    } else {
      this.spinnerVisible = false;
      const modelRef = this.ngbModel.open(LoginComponent, {
        size: 'lg',
        windowClass: 'login-dialog',
      });
      modelRef.result.then((data) => {
        this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
        if (this.userDetails != null && this.userDetails != '')
          this.SaveTemplateData(isGenerateVideo);
      });
      //this.isShowLoader = false;
      this.sharedService.isShowLoader.next(false);
    }
  }

  public updateFileList(file, fieldName, elementObj: any) {
    for (let fileItem of this.fileList) {
      if (fileItem.fieldName == fieldName) {
        this.fileList.splice(this.fileList.indexOf(fileItem), 1);
        break;
      }
    }
    var lastThree = file.name.substr(file.name.length - 3);
    var lastFour = file.name.substr(file.name.length - 4);

    if (
      lastThree.toLowerCase() != 'jpg' &&
      lastFour.toLowerCase() != 'jpeg' &&
      lastThree.toLowerCase() != 'png'
    ) {
      this.messageService.showMessage(
        'Please use .jpg, .jpeg, .png file',
        this.messageType.Error
      );
      $('#' + fieldName).val('');
      return;
    }
    if (file.size > 10485760) {
      //2MB:2097152,10MB
      this.messageService.showMessage(
        'Maximum size should be 10MB.',
        this.messageType.Error
      );
      $('#' + fieldName).val('');
      return;
    }
    //const formData = new FormData();
    //formData.append('file', file);
    if (elementObj.FieldType == 'Picture') {
      this.singleFileList = [];
      this.singleFileList.push({ fieldName: fieldName, file: file });
      let objRequestData = Object.assign({});
      objRequestData.IsRemoveBg = elementObj?.IsRemoveBg ?? false;
      this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
      objRequestData.UserId =
        this.userDetails == null || this.userDetails == undefined
          ? 0
          : this.userDetails.UserId;
      this.sharedService.isShowLoader.next(true);
      this._httpService
        .ajaxPostFileList(
          'Personalize/UploadTemplateFile',
          this.singleFileList,
          objRequestData
        )
        .then(
          (data: any) => {
            elementObj.FileCroppedValue =
              this._httpService.baseURL + data.FilePath;
            elementObj.FieldValue = data.FilePath;
            this.modalService.dismissAll();
            this.imageUploading = false;
            this.sharedService.isShowLoader.next(false);
          },
          () => {
            this.sharedService.isShowLoader.next(false);
          }
        );
    } else {
      this.fileList.push({ fieldName: fieldName, file: file });
    }
  }

  fileClickEvent(event: any): void {
    if (event.target.files.length > 0) {
      event.srcElement.value = null;
    }
  }

  // Image Cropping
  fileChangeEvent(event: any, fieldName): void {
    var files = event.target.files;
    if (files[0].type.match(/image-*/)) {
      this.fieldName = fieldName;
      this.TemplateMetaData.SlideData.forEach((element) => {
        element.FieldData.forEach((elementObj) => {
          if (elementObj.FieldName == fieldName) {
            elementObj.FileEvent = event;

            if (
              elementObj.AspectRatio != '' &&
              elementObj.AspectRatio != null &&
              elementObj.AspectRatio != undefined
            ) {
              this.aspectRatio = parseFloat(elementObj.AspectRatio);
              this.isMaintainAspectRatio = true;
            } else {
              this.aspectRatio = 1;
              this.isMaintainAspectRatio = true;
            }

            if (
              elementObj.FieldShapeId != '' &&
              elementObj.FieldShapeId != null &&
              elementObj.FieldShapeId != undefined
            ) {
              this.fieldShapeId = elementObj.FieldShapeId;
            } else this.fieldShapeId = 1;
          }
        });
      });
      this.editImageFile = event?.target.files[0];
      this.croppedImageFile = event?.target.files[0];
      this.imageUploading = false;
      const modelRef = this.modalService.open(ImageCropperControlComponent, {
        size: 'lg',
        windowClass: 'img-cropper'
      });
      modelRef.componentInstance.inputFile = event;
      modelRef.componentInstance.fieldShapeId = this.fieldShapeId;
      modelRef.componentInstance.aspectRatio = this.aspectRatio;
      modelRef.result.then((result) => {
        if (this.croppedImageFile != undefined) {
          this.croppedImageFile = result;
          this.saveImageCropped();
        }
      });
      //this.modalService.open(this.imageCropperModal);
    } else {
      this.toastr.error('Please upload valid image');
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImageFile = event;
  }

  saveImageCropped() {
    this.isInputChanged = true;
    this.imageUploading = true;
    this.TemplateMetaData.SlideData.forEach((element) => {
      element.FieldData.forEach((elementObj) => {
        if (elementObj.FieldName == this.fieldName) {
          elementObj.IsEdited = true;
          file: File;
          const FileBeforeCrop = elementObj.FileEvent.target.files[0];
          var file: any;

          var result = this.b64toBlob(this.croppedImageFile.base64);
          const fileToUpload: File = this.blobToFile(
            result,
            this.fieldName + '.png'
          );
          var fileName: any;
          this.file = fileToUpload;
          fileName = this.file['name'];
          if (this.file) {
            var reader = new FileReader();
            reader.onload = (event: any) => {
              this.localUrl = event.target.result;
              this.compressFile(
                this.localUrl,
                this.file['name'],
                elementObj,
                fileToUpload
              );
            };
            reader.readAsDataURL(result);
          }
        }
      });
    });
  }
  file: any;
  localUrl: any;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;
  compressFile(image, fileName, elementObj, fileToUpload) {
    var orientation = -1;
    this.sizeOfOriginalImage =
      this.imageCompress.byteCount(image) / (1024 * 1024);
    if (this.sizeOfOriginalImage < 10) {
      this.updateFileList(fileToUpload, this.fieldName, elementObj);
    } else {
      this.imageCompress
        .compressFile(image, orientation, 50, 80)
        .then((result) => {
          this.imgResultAfterCompress = result;
          this.localCompressedURl = result;
          this.sizeOFCompressedImage =
            this.imageCompress.byteCount(result) / (1024 * 1024);
          const imageBlob = this.dataURItoBlob(
            this.imgResultAfterCompress.split(',')[1]
          );
          const fileToUpload: File = this.blobToFile(
            imageBlob,
            this.fieldName + '.png'
          );
          this.updateFileList(fileToUpload, this.fieldName, elementObj);
        });
    }
  }
  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }
  b64toBlob(dataURI) {
    return this.b64toBlobNew(dataURI.split(',')[1]);
  }
  b64toBlobNew(b64Data, contentType = 'image/jpeg', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  blobToFile = (theBlob: Blob, fileName: string): File => {
    var b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;
    return <File>theBlob;
  };

  public GenerateVideo(e) {
    if (this.isShowPreviewStatus) {
      this.toastr.warning(
        'Video generation is in progress. Please stay with us.'
      ); 
      return;
    }
    this.sharedService.isShowLoader.next(true);
    this.subscription.add(
      this._httpService
        .ajaxPost(
          `Personalize/CheckVideoStatus/${this.pUserVideoId}/${this.invitationType}`,
          null
        )
        .subscribe(
          (data: any) => {
            this.sharedService.isShowLoader.next(false);
            if (data) {
              if (
                (this.generatedVideoPath.length > 0 ||
                  this.generatedDocumentPath.length > 0) &&
                this.isInputChanged == false
              ) {
                this.openHowItWorksDialog(
                  this.generatedVideoPath,
                  this.generatedDocumentPath
                );
                return;
              } else {
                if (this.isShowPreviewStatus) {
                  return;
                }
                if (!this.isDraftSaved || this.isInputChanged == true)
                  this.SaveTemplateData(true);
                else this.createVideo();

                var errorExist = false;

                if (errorExist) {
                  return;
                }
              }
            } else {
              if (this.isShowPreviewStatus) {
                return;
              }
              if (!this.isDraftSaved || this.isInputChanged == true)
                this.SaveTemplateData(true);
              else this.createVideo();

              var errorExist = false;

              if (errorExist) {
                return;
              }
            }
          },
          () => {
            this.sharedService.isShowLoader.next(false);
          }
        )
    );
  }
  createVideo() {
    this.invokeHubConnection();
  }
  processVideoGeneration() {
    this.goToSlide(this.TemplateMetaData?.SlideData?.length + 1);
    var fileList = this.fileList;
    this.TemplateMetaData.VideoStatus = this.constants.videoStatus.Previewed;
    this.TemplateMetaData.UniqueTemplateId = this.uniqueTemplateId;
    this.spinnerVisible = true;
    this.isShowPreviewStatus = true;
    this.isShowPreviewStatusStyle = '';

    this.isSaveDisable = true;
    this.subscription.add(
      this._httpService
        .ajaxPost('Personalize/UpdateTemplate', {
          TemplateMetaData: this.TemplateMetaData,
        })
        .subscribe(
          (data) => {
            if (
              data['Message'] != undefined &&
              data['Message'].Text.toLowerCase() == 'stop process'
            )
              return;
            try {
              if (
                data['Message'].MessageTypeValue == this.messageType.Success
              ) {
                this.oldFileList = fileList;
                this.oldTemplateData = this.TemplateMetaData;
                this.isInputChanged = false;
                if (data['IsUseS3Bucket']) {
                  this.videoPath = data['VideoPath'];
                  this.documentPath = data['DocumentPath'];
                } else {
                  this.videoPath =
                    this._httpService.baseURL + data['VideoPath'];
                  this.documentPath =
                    this._httpService.baseURL + data['DocumentPath'];
                }
                if (data['VideoPath'] != '' || data['DocumentPath'] != '') {
                  this.generatedVideoPath = this.videoPath;
                  this.generatedDocumentPath = this.documentPath;
                  this.isPayDisable = false;
                } else this.isPayDisable = true;
                this.spinnerVisible = false;
                $('#ResultVideoId').attr('src', this.videoPath);
                this.isShowPreviewStatus = false;
                this.isShowPreviewStatusStyle = 'display:none';
                this.ProgressBarPercentage = '0';
                this.ProgressBarClass = `c100 p${0} green`;
                this.openHowItWorksDialog(this.videoPath, this.documentPath);
              } else {
                this.isPayDisable = true;
                this.spinnerVisible = false;
                this.isShowPreviewStatus = false;
                // this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
                if (
                  data['Message'] != undefined &&
                  data['Message'].MessageTypeValue ==
                  this.messageType.RequestExist
                ) {
                  const modelRef = this.modalService.open(
                    ConfirmationBoxComponent
                  );
                  modelRef.componentInstance.title =
                    'Video already in generation';
                  modelRef.componentInstance.message = `You are already generating another video. Please note that only one video can be generated per user at a time. Kindly proceed with this request once you have completed the preview of the previous one.`;
                  modelRef.componentInstance.okButtonText = 'Okay';
                  modelRef.componentInstance.cancelButtonText = 'Cancel';
                } else {
                  this.videoGenerationError();
                }
              }
              this.isSaveDisable = false;
            } catch (error) {
              this.isPayDisable = true;
              this.isSaveDisable = false;
              console.error(error);
              this.spinnerVisible = false;
              this.isShowPreviewStatus = false;
            }
          },
          (error: any) => {
            this.isShowPreviewStatus = false;
            this.isSaveDisable = false;
          }
        )
    );
  }

  openHowItWorksDialog(path: string, documentPath: string): void {
    let dialogRef = this.modalService.open(HowItWorksComponent, {
      size: 'lg',
      windowClass: 'preview-video-dialog',
    });
    dialogRef.componentInstance.userVideoId = this.pUserVideoId;
    dialogRef.componentInstance.videoPath = path;
    dialogRef.componentInstance.documentPath = documentPath;
    dialogRef.componentInstance.UserId = this.userDetails.UserId;
    dialogRef.componentInstance.displayType = this.displayType;
    dialogRef.componentInstance.previewStyle = this.previewStyle;
    dialogRef.componentInstance.invitationType = this.invitationType;

    dialogRef.result.then((data) => {
      if (data) {
        this.sharedService.isShowLoader.next(true);
        this.subscription.add(
          this._httpService
            .ajaxPost(
              `Personalize/CheckVideoStatus/${this.pUserVideoId}/${this.invitationType}`,
              null
            )
            .subscribe(
              (data: any) => {
                if (data) {
                  this.ProcessPayAndDownload();
                } else {
                  this.sharedService.isShowLoader.next(false);
                  this.SaveTemplateData(true);
                }
              },
              () => {
                this.sharedService.isShowLoader.next(false);
                this.SaveTemplateData(true);
              }
            )
        );
      }
    });
  }
  videoGenerationError() {
    this.isInputChanged = true;
    const modelRef = this.modalService.open(ConfirmationBoxComponent);
    modelRef.componentInstance.title =
      'Unexpected Error While Generating a Video';
    modelRef.componentInstance.message = `We hit a bit of a unexpected error while making your video/card. 
  No worries, though! Your video details are saved in "My Videos" section and you can give it another try for video generation. <strong style='color:#ED256B'> If you run into any trouble again or have questions, just reach out to our friendly support executive on a website chat or on WhatsApp at +91 8669278777 </strong>. 
  We're always here to assist you and make things as smooth as possible for you.`;
    modelRef.componentInstance.okButtonText = 'Okay';
    modelRef.componentInstance.cancelButtonText = 'Cancel';
  }
  GoToHomePage() {
    this._router.navigate(['homepage']);
  }

  onCarouselChange(e) {
    this.activeSlide = e.startPosition;
  }

  goToSlide(i) {
    this.personalizeVideo.to(String(i));
  }
  useAudioOnChange(isChecked) {
    let items = this.fileList;
    this.isInputChanged = true;
    if (isChecked) {
      this.fileList = this.fileList.filter(
        (x) => x.fieldName != 'TemplateAudioFile'
      );
      this.audioFile.nativeElement.value = '';
      this.uploadMusicText = 'Upload Your Audio';
    }
  }
  textChange(casingTypeId, itemObj: any) {
    this.isInputChanged = true;
    switch (casingTypeId) {
      case 1: {
        itemObj.FieldValue = this.toTitleCase(itemObj.FieldValue);
        break;
      }
      case 2: {
        itemObj.FieldValue = this.toUpperCase(itemObj.FieldValue);
        break;
      }
      case 3: {
        itemObj.FieldValue = this.toLowerCase(itemObj.FieldValue);
        break;
      }
      default: {
        break;
      }
    }
  }
  checkboxChange(slideItem) {
    var slideIncludeField = slideItem.FieldData.filter(
      (x) => x.FieldName == 'SlideInclude'
    )[0];
    if (
      slideIncludeField?.FieldValue != null &&
      slideIncludeField?.FieldValue.toString() != ''
    ) {
      let result = !(slideIncludeField.FieldValue.toString() == 'false'
        ? false
        : true);
      slideIncludeField.FieldValue = result;
      slideItem.IsIncluded = result;
    } else {
      slideIncludeField.FieldValue = true;
      slideItem.IsIncluded = true;
    }
    this.isInputChanged = true;
  }
  payAndDownload() {
    this.sharedService.isShowLoader.next(true);
    this.subscription.add(
      this._httpService
        .ajaxPost(
          `Personalize/CheckVideoStatus/${this.pUserVideoId}/${this.invitationType}`,
          null
        )
        .subscribe(
          (data: any) => {
            if (data) {
              if (this.isShowPreviewStatus) {
                return;
              }
              this.ProcessPayAndDownload();
            } else {
              this.sharedService.isShowLoader.next(false);
              this.SaveTemplateData(true);
            }
          },
          () => {
            this.sharedService.isShowLoader.next(false);
            this.videoGenerationError();
          }
        )
    );
  }
  private ProcessPayAndDownload() {
    if (
      this.generatedVideoPath.length !== 0 ||
      this.generatedDocumentPath.length !== 0
    ) {
      let encryptedqueryparams: { userVideoId: any };
      encryptedqueryparams = {
        userVideoId: this.pUserVideoId,
      };
      this.sharedService.isShowLoader.next(true);
      let objLog = Object.assign({});
      objLog.UserId = this.userDetails.UserId;
      objLog.MethodName = 'Pay & Downlaod';
      objLog.IsSuccess = true;
      objLog.Description = `User clicked download => ${this.generatedVideoPath}`;
      objLog.IPAddress = this.sharedService.ipAddress;
      this.subscription.add(
        this._httpService
          .ajaxPost('Personalize/AddLog', objLog)
          .subscribe((data) => {
            this.sharedService.isShowLoader.next(false);
            this._router.navigate([
              `/userpayment/${this.videoDesc}/${this.sharedService.encryptData(
                JSON.stringify(encryptedqueryparams)
              )}`,
            ]);
          })
      );
    } else {
      this.toastr.warning(
        'Please generate the preview video first and then you can proceed for payment.'
      );
      this.isPayDisable = true;
      setTimeout(() => {
        this.isPayDisable = false;
      }, 5000);
    }
  }

  addLog(data: any) { }

  replaceBetween(input, start, end, what) {
    return input.substring(0, start) + what + input.substring(end);
  }
  slidePreview(item: any) {
    // if (localStorage.getItem("previewnote") === null || localStorage.getItem("previewnote") === undefined) {
    //   const modelRef = this.modalService.open(ConfirmationBoxComponent, { size: 'sm', backdrop: 'static' });
    //   modelRef.componentInstance.title = "Plese note";
    //   modelRef.componentInstance.message = "Information: Slide preview does not contain animations and is not HD quality. Kindly upload all images, text and preview HD quality video with animations.";
    //   modelRef.componentInstance.okButtonText = "Okay";
    //   modelRef.componentInstance.cancelButtonText = "Yes";
    //   modelRef.componentInstance.showCancel = false;
    //   modelRef.result.then((data: any) => {
    //     localStorage.setItem("previewnote", "Y");
    //     this.generateSlidePreview(item);
    //   })
    // }
    // else {
    this.generateSlidePreview(item);
    // }
  }
  generateSlidePreview(item) {
    let errorExist = false;
    let currentTemplateData = { ...this.TemplateMetaData };
    currentTemplateData.SlideData = currentTemplateData.SlideData.filter(
      (obj, index) => index == this.activeSlide
    );
    currentTemplateData.SlideData.forEach((element) => {
      if (errorExist == false) {
        element.FieldData.forEach((elementObj) => {
          if (!errorExist) {
            if (elementObj.FieldType.toLowerCase() == 'picture') {
              if (elementObj.FileCroppedValue == '') {
                this.toastr.error(
                  'Please select all images from all included clips.'
                );
                errorExist = true;
                this.sharedService.isShowLoader.next(false);
                return;
              }
            }
          }
        });
      }
    });
    if (errorExist) return;
    this.previewGenerationInProgress = true;
    currentTemplateData.CurrentSlideSequenceNumber =
      currentTemplateData.SlideData[0].SlideSequence;
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    currentTemplateData.UserId =
      this.userDetails == null || this.userDetails == undefined
        ? 0
        : this.userDetails.UserId;
    this.subscription.add(
      this._httpService
        .ajaxPost('Personalize/GenerateSlidePreview', {
          TemplateMetaData: currentTemplateData,
        })
        .subscribe(
          (data: any) => {
            this.TemplateMetaData.SlideData[this.activeSlide].SlideImageLink =
              this._httpService.baseURL + data.PreviewImagePath;
            this.cdr.detectChanges();
            this.previewGenerationInProgress = false;
          },
          () => {
            this.previewGenerationInProgress = false;
          }
        )
    );
  }
  validateSlide(): boolean {
    let errorExist = false;
    this.TemplateMetaData.SlideData[this.activeSlide].FieldData.forEach(
      (elementObj) => {
        if (errorExist == false) {
          if (!errorExist) {
            if (elementObj.FieldType.toLowerCase() == 'picture') {
              if (elementObj.FileCroppedValue == '') {
                this.toastr.error('Please select all images from this slides.');
                errorExist = true;
              }
            }
          }
        }
      }
    );
    return !errorExist;
  }
  private redirectToDownloadVideo() {
    let encryptedqueryparams: { userVideoId: any };
    encryptedqueryparams = {
      userVideoId: this.pUserVideoId,
    };
    this._router.navigate([
      `/user/downloadvideo/${this.videoDesc}/${this.sharedService.encryptData(
        JSON.stringify(encryptedqueryparams)
      )}`,
    ]);
  }
  changeAudio(filePath, isInputChanged = false) {
    this.isInputChanged = isInputChanged;
    this.showAudioPlayer = false;
    this.audioList = [];
    let selectedAudio = this.TemplateMetaData.TemplateAudio.filter(
      (x) => x.AudioPath == filePath
    )[0];
    let objAudio = Object.assign({});
    objAudio.url = environment.baseURL + filePath;
    objAudio.title =
      selectedAudio.AudioTitle.length > 50
        ? `${selectedAudio.AudioTitle.substring(0, 50)}...`
        : selectedAudio.AudioTitle;
    objAudio.Cover = selectedAudio.AudioCoverPath;
    this.audioPath = filePath;
    this.finalAudioPath = objAudio.url;
    this.audioList.push(objAudio);
    setTimeout(() => {
      this.showAudioPlayer = true;
    }, 1);
  }
  toTitleCase(str) {
    return this.titlecasePipe.transform(str);
  }
  toUpperCase(str) {
    return toUpper(str);
  }
  toLowerCase(str) {
    return toLower(str);
  }
  ngOnDestroy() {
    if (this.connection != undefined) this.connection.stop();
    if (this.subscription != undefined) this.subscription.unsubscribe();
    this.renderer.removeClass(document.body, 'body-no-scroll');
    this.footerService.showHeader();
    this.renderer.removeClass(document.body, 'hide-header-from-personlized');
  }
  // drop(event: CdkDragDrop<any[]>) {
  //   // Reorder the slide data array based on the drop event
  //   const draggedItem = event.item.data;
  //   const currentIndex = this.TemplateMetaData.SlideData.indexOf(draggedItem);
  //   const targetIndex = event.currentIndex;

  //   // Perform the reorder
  //   this.TemplateMetaData.SlideData.splice(currentIndex, 1);
  //   this.TemplateMetaData.SlideData.splice(targetIndex, 0, draggedItem);
  // }

  // drop($event: CdkDragDrop<{title: string, poster: string}[]>) {
  //   moveItemInArray(
  //     this.TemplateMetaData.SlideData,
  //     $event.previousIndex,
  //     $event.currentIndex
  //   );
  // }
  container = {
    row1: ['1', '2', '3', '4', '5'],
  };

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  openInsText() {
    const modalReference = this.modalService.open(InsTextComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
    });
  }

  toggleSlideIn(contentType: string) {
    this.isOpen = !this.isOpen;
    this.selectedContent = contentType;
    const slideInContainer = document.querySelector(
      '.slide-in-container'
    ) as HTMLElement;
    if (this.isOpen) {
      slideInContainer.style.marginRight = '0';
    } else {
      slideInContainer.style.marginRight = '-100%';
    }
  }
  scrollToInput(): void {
    // if(this.isIosDevice){
    //   return;
    // }
    // const inputElement = document.getElementById('first-input');

    // if (inputElement) {
    //   inputElement.scrollIntoView({ behavior: 'smooth' });
    //   setTimeout(() => {
    //     window.scrollBy({ top: -5, behavior: 'smooth' });
    //     inputElement.focus();
    //   }, 300);
    // }
  }
  goBack() {
    this.location.back();
  }
}
